import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('Firework').create(() => ({
  iframe: {
    position: 'absolute',
    width: '100vw',
    height: '100vh',
    zIndex: '0',
    border: 'none',
  },
}))
